/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_No_AudioInputs */

const th_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูวิดีโอได้ แต่เบราว์เซอร์นี้ไม่รองรับเสียง`)
};

const en_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video is available, but sound is not supported in this browser.`)
};

const ja_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`映像は利用できますが、このブラウザーでは音声に対応していません。`)
};

const zh_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频可用，但此浏览器不支持它的音频。`)
};

const es_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay vídeo, pero este navegador no admite sonido.`)
};

const pt_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há vídeo, mas este navegador não suporta som.`)
};

const id_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video tersedia, tapi peramban ini tidak mendukung suaranya.`)
};

const fr_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vidéo est disponible, mais le son n’est pas pris en charge par ce navigateur.`)
};

const tl_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available ang video, ngunit hindi sinusuportahan ng browser na ito ang tunog nito.`)
};

const vi_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có video, nhưng trình duyệt này không hỗ trợ âm thanh của nó.`)
};

const ko_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영상은 볼 수 있지만 이 브라우저는 소리를 지원하지 않습니다.`)
};

const de_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ist verfügbar, Ton unterstützt dieser Browser aber nicht.`)
};

const ru_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео доступно, но этот браузер не поддерживает его звук.`)
};

const tr_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntü var ama bu tarayıcı sesini desteklemiyor.`)
};

const it_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il video è disponibile, ma questo browser non ne supporta l'audio.`)
};

const pl_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obraz jest dostępny, ale ta przeglądarka nie obsługuje jego dźwięku.`)
};

const uk_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відео доступне, але цей браузер не підтримує його звук.`)
};

const hi_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो उपलब्ध है, पर यह ब्राउज़र उसकी ध्वनि नहीं चला सकता।`)
};

const ar_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفيديو متاح، لكن هذا المتصفح لا يدعم صوته.`)
};

const ms_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video tersedia, tetapi pelayar ini tidak menyokong bunyinya.`)
};

const bn_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভিডিও আছে, তবে এই ব্রাউজার এর শব্দ চালাতে পারে না।`)
};

const zh_tw2_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影片可以觀看，但這個瀏覽器不支援它的音訊。`)
};

const zh_hk2_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短片可以觀看，但這個瀏覽器不支援它的音訊。`)
};

const ur_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ویڈیو دستیاب ہے، مگر یہ براؤزر اس کی آواز نہیں چلا سکتا۔`)
};

const fa_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصویر هست، اما این مرورگر صدایش را پشتیبانی نمی‌کند.`)
};

const sw_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ipo, lakini kivinjari hiki hakiwezi kucheza sauti yake.`)
};

const nl_video_no_audio = /** @type {(inputs: Video_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is beeld, maar deze browser ondersteunt het geluid ervan niet.`)
};

/**
* | output |
* | --- |
* | "Video is available, but sound is not supported in this browser." |
*
* @param {Video_No_AudioInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_no_audio = /** @type {((inputs?: Video_No_AudioInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_No_AudioInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_no_audio(inputs)
	if (locale === "ja") return ja_video_no_audio(inputs)
	if (locale === "zh") return zh_video_no_audio(inputs)
	if (locale === "es") return es_video_no_audio(inputs)
	if (locale === "pt") return pt_video_no_audio(inputs)
	if (locale === "id") return id_video_no_audio(inputs)
	if (locale === "fr") return fr_video_no_audio(inputs)
	if (locale === "tl") return tl_video_no_audio(inputs)
	if (locale === "vi") return vi_video_no_audio(inputs)
	if (locale === "ko") return ko_video_no_audio(inputs)
	if (locale === "de") return de_video_no_audio(inputs)
	if (locale === "ru") return ru_video_no_audio(inputs)
	if (locale === "tr") return tr_video_no_audio(inputs)
	if (locale === "it") return it_video_no_audio(inputs)
	if (locale === "pl") return pl_video_no_audio(inputs)
	if (locale === "uk") return uk_video_no_audio(inputs)
	if (locale === "hi") return hi_video_no_audio(inputs)
	if (locale === "ar") return ar_video_no_audio(inputs)
	if (locale === "ms") return ms_video_no_audio(inputs)
	if (locale === "bn") return bn_video_no_audio(inputs)
	if (locale === "zh-TW") return zh_tw2_video_no_audio(inputs)
	if (locale === "zh-HK") return zh_hk2_video_no_audio(inputs)
	if (locale === "ur") return ur_video_no_audio(inputs)
	if (locale === "fa") return fa_video_no_audio(inputs)
	if (locale === "sw") return sw_video_no_audio(inputs)
	if (locale === "nl") return nl_video_no_audio(inputs)
	return en_video_no_audio(inputs)
});